import styled from "styled-components";

export const WizardStepperWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const StepSeparator = styled.div`
  width: 20px;
  height: 1px;
  background-color: var(--mode-border-neutral-weakest);
`;
